import { defineStore } from "pinia";
import { shallowRef, ref } from "vue";
import type { User } from "b2b-common/models/auth";
import { api } from "../../lib/api";
export const useAuth = defineStore("auth", () => {
  const user = shallowRef<User | null>(null);
  const ready = ref(false);
  const identity = ref("");
  let restoring: Promise<void> | undefined;
  async function restore() {
    if (ready.value) return;
    restoring ??= api.auth
      .getClientData()
      .then((value) => {
        value.isMandated =
          value.isMandated === true || String(value.isMandated) === "t";
        user.value = value?.username ? value : null;
        identity.value = value?.username
          ? `${value.clientCode}:${value.username}`
          : "";
      })
      .catch(() => {
        user.value = null;
      })
      .finally(() => {
        ready.value = true;
      });
    return restoring;
  }
  async function login(client: string, username: string, password: string) {
    const value = await api.auth.login(
      client.trim(),
      username.trim(),
      password,
    );
    if (!value.username) throw new Error("Invalid session");
    value.isMandated =
      value.isMandated === true || String(value.isMandated) === "t";
    user.value = value;
    identity.value = `${value.clientCode}:${value.username}`;
    ready.value = true;
  }
  async function logout() {
    await api.auth.logout();
    user.value = null;
  }
  return { user, identity, ready, restore, login, logout };
});
